/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

/** @module components/signup-overlay */
import baustein from "baustein";
import analytics from "analytics/analytics";
import environment from "modules/environment";
import history from "../../utils/history";
import overlayMixin from "components/mixins/overlay-mixin";
import requester from "modules/requester";
import globals from "../../modules/globals";
import LoginOverlay from "components/overlays/login-overlay";

/**
 * Handles functionality of the new sign up overlay
 *
 * @constructor
 * @alias module:components/signup-overlay
 * @extends module:baustein
 */
export default baustein.register(
    "signup-overlay",
    /** @lends module:components/signup-overlay.prototype */
    {
        mixins: [overlayMixin],

        defaultOptions: {
            isOverlay: false,
            overlaySize: "large",
            noContentPadding: true,
            queryParams: {},
            // todo i18n urls
            path: "/account/register/",
            formType: "unknown",
            loginSuccessRedirectUrl: window.location.pathname + window.location.search
        },

        setupEvents(add) {
            add("userSuccessfullyRegistered", this.userSuccessfullyRegistered);
            add("click", ".login-link", this.switchToLogin);
        },

        onOverlayCloseIntent() {
            if (this.options.isOverlay) {
                const eventCategory = this._getEventCategory();
                analytics.event(eventCategory, "close_signup_form", "exit_signup");
                history.back();
                this.close();
            }
        },

        onOverlayOpen() {
            if (this.options.isOverlay) {
                this.trackPageView();
            }
        },

        getOverlayContent() {
            return requester(this.options.path, {
                headers: {
                    Accept: "text/html"
                },
                query: this.options.queryParams
            }).then(resp => {
                // If we get back application/json then the user is
                // already logged in. Perhaps a further improvement -
                // we detect this when the save for later button is
                // clicked and redirect + save for later at the same
                // time
                if (
                    resp.status === 200 &&
                    resp.headers.get("content-type") === "application/json"
                ) {
                    globals.window.location = this.options.loginSuccessRedirectUrl;
                    return;
                } else {
                    return requester.toText(resp);
                }
            });
        },

        trackPageView() {
            analytics.pageView();
        },

        switchToLogin(event) {
            if (event) {
                event.preventDefault();
            }
            this.close();
            const eventCategory = this._getEventCategory();
            analytics.event(eventCategory, "toggle", "sign_in");
            const pageType = "signin_form";
            const pageSubType = eventCategory.replace("signup", "signin");
            environment.set({
                pageType,
                pageSubType,
            });
            const overlay = new LoginOverlay({
                queryParams: this.options.queryParams,
            });
            overlay.appendTo(document.body);
            overlay.open();
        },

        _getEventCategory(){
            const newSignupFormComponent = this.findComponent("signup-form");
            return newSignupFormComponent.options.eventCategory;
        }
    }
);

